export const COMPARE_OPTIONS_ENUM = {
  PREVIOUS_PERIOD: 1,
  PREVIOUS_YEAR: 2
};
